import createTestId from "../../../../fabrics/createTestId";
import { BUTTON_CIRCLE_DISPLAY_NAME } from "../ButtonCircle";

export const createTestIdForButtonCircleElement = createTestId(
    BUTTON_CIRCLE_DISPLAY_NAME,
);
